"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _PassengerRoomSelection = _interopRequireDefault(require("@airasia/phoenix-components/components/PassengerRoomSelection"));

var _constant = require("../constant");

var _constant2 = require("./constant");

var _multiRoomSelect = _interopRequireDefault(require("./multiRoomSelect.util"));

var _multiRoomSelect2 = _interopRequireDefault(require("./multiRoomSelect.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var MultiRoomSelectWrapper = _styledComponents.default.div.withConfig({
  displayName: "MultiRoomSelect__MultiRoomSelectWrapper",
  componentId: "sc-1q50kgw-0"
})(["position:relative;cursor:pointer;-webkit-tap-highlight-color:transparent;background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.backgroundColor.default;
});

var DesktopModal = _styledComponents.default.div.withConfig({
  displayName: "MultiRoomSelect__DesktopModal",
  componentId: "sc-1q50kgw-1"
})(["position:absolute;width:360px;background-color:", ";border:1px solid ", ";box-shadow:", ";border-radius:", ";z-index:1;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.backgroundColor.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.greyLight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return "0px 1px ".concat(theme.space.mini, " rgba(0, 0, 0, 0.1), 0px ").concat(theme.space.mini, " ").concat(theme.space.tiny, " rgba(0, 0, 0, 0.1)");
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.normal;
});

var MobileModal = _styledComponents.default.div.withConfig({
  displayName: "MultiRoomSelect__MobileModal",
  componentId: "sc-1q50kgw-2"
})(["position:fixed;height:100vh;top:0;left:0;background-color:", ";z-index:11;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.backgroundColor.primary;
});

var MobileModalHeader = _styledComponents.default.div.withConfig({
  displayName: "MultiRoomSelect__MobileModalHeader",
  componentId: "sc-1q50kgw-3"
})(["display:flex;justify-content:space-between;background-color:", ";padding:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.backgroundColor.primary;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.small;
});

var ModalCloseButton = _styledComponents.default.div.withConfig({
  displayName: "MultiRoomSelect__ModalCloseButton",
  componentId: "sc-1q50kgw-4"
})([""]);

var MultiRoomSelectInputWrapper = _styledComponents.default.div.withConfig({
  displayName: "MultiRoomSelect__MultiRoomSelectInputWrapper",
  componentId: "sc-1q50kgw-5"
})(["display:flex;align-items:center;min-height:56px;min-width:240px;padding:0 ", ";border:", ";border-radius:4px;"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.XSmall;
}, function (_ref10) {
  var theme = _ref10.theme,
      openModal = _ref10.openModal;
  return "1px solid ".concat(openModal ? theme.colors[_constant2.DEFAULT_STYLE.INPUT.ACTIVE_BORDER_COLOR] : theme.colors[_constant2.DEFAULT_STYLE.INPUT.DEFAULT_BORDER_COLOR]);
});

var InputLabelContainer = _styledComponents.default.div.withConfig({
  displayName: "MultiRoomSelect__InputLabelContainer",
  componentId: "sc-1q50kgw-6"
})(["display:flex;flex:1;flex-direction:column;padding:", ";"], function (_ref11) {
  var theme = _ref11.theme,
      isOnlyApplyForHotel = _ref11.isOnlyApplyForHotel,
      viewport = _ref11.viewport;

  if (isOnlyApplyForHotel && viewport === _constant.DEVICE_TYPE.MOBILE) {
    return " 0 ".concat(theme.space.XSmall, " 0px 0px");
  }

  return "0 ".concat(theme.space.XSmall);
});

var IconPaxStyle = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "MultiRoomSelect__IconPaxStyle",
  componentId: "sc-1q50kgw-7"
})(["color:", ";"], function (_ref12) {
  var isOnlyApplyForHotel = _ref12.isOnlyApplyForHotel,
      theme = _ref12.theme;
  return isOnlyApplyForHotel ? theme.colors.greyMediumDark : theme.colors[_constant2.DEFAULT_STYLE.ICON.COLOR];
});

var MultiRoomSelect = function MultiRoomSelect(props) {
  var data = props.data,
      device = props.device,
      iconName = props.iconName,
      onChangeData = props.onChangeData,
      maxPassengerLimit = props.maxPassengerLimit,
      theme = props.theme,
      accessible = props.accessible,
      customProperties = props.customProperties,
      isOnlyApplyForHotel = props.isOnlyApplyForHotel,
      alwayEnableAddRoom = props.alwayEnableAddRoom,
      isShowChildAgeInput = props.isShowChildAgeInput,
      isShowInfantSelect = props.isShowInfantSelect;

  var _ref13 = data || {},
      roomOccupancy = _ref13.roomOccupancy,
      minRooms = _ref13.minRooms,
      child = _ref13.child,
      infant = _ref13.infant,
      minPassengers = _ref13.minPassengers,
      labels = _ref13.labels,
      childAgeData = _ref13.childAgeData;

  var _ref14 = labels || {},
      multiRoomSelectTitle = _ref14.multiRoomSelectTitle,
      passengerModalHeaderLabel = _ref14.passengerModalHeaderLabel,
      roomSingle = _ref14.roomSingle,
      roomPlural = _ref14.roomPlural,
      guestSingle = _ref14.guestSingle,
      guestPlural = _ref14.guestPlural;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      openModal = _useState2[0],
      setOpenModal = _useState2[1];

  var defaultRoomOccupancy = {
    adult: +minPassengers || 1,
    child: +child.min || 0,
    infant: +infant.min || 0
  };

  var _useState3 = (0, _react.useState)(_multiRoomSelect.default.updateRoomOccupancy(roomOccupancy, minRooms, defaultRoomOccupancy)),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      updatedRoomOccupancy = _useState4[0],
      setUpdatedRoomOccupancy = _useState4[1];

  var _useState5 = (0, _react.useState)(_multiRoomSelect.default.getTotalGuests(updatedRoomOccupancy)),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      totalGuests = _useState6[0],
      setTotalGuests = _useState6[1];

  var _useState7 = (0, _react.useState)(updatedRoomOccupancy.length),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      totalRooms = _useState8[0],
      setTotalRooms = _useState8[1];

  var _useState9 = (0, _react.useState)(childAgeData !== null && childAgeData !== void 0 ? childAgeData : null),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      childAge = _useState10[0],
      setChildAge = _useState10[1];

  (0, _react.useEffect)(function () {
    setChildAge(childAgeData);
  }, [childAgeData]);
  /* ------ close passenger selection modal on clicking outside ----- */

  var wrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setUpdatedRoomOccupancy(_multiRoomSelect.default.updateRoomOccupancy(roomOccupancy, minRooms, defaultRoomOccupancy));
  }, [roomOccupancy, minRooms]);
  (0, _react.useEffect)(function () {
    setTotalGuests(_multiRoomSelect.default.getTotalGuests(updatedRoomOccupancy));
    setTotalRooms(updatedRoomOccupancy.length);
  }, [updatedRoomOccupancy]);

  var handleClickOutside = function handleClickOutside() {
    setOpenModal(false);
  };

  _utilities.default.useOutsideClickHandler(wrapperRef, handleClickOutside);
  /* ------------------------------------------------------------------ */


  var onRoomSubmit = function onRoomSubmit(paxPerRoom, guests, rooms, newChildAge) {
    if (onChangeData) onChangeData(paxPerRoom, newChildAge);
    if (isShowChildAgeInput) setChildAge(newChildAge);
    setTotalGuests(guests);
    setTotalRooms(rooms);
    setUpdatedRoomOccupancy(paxPerRoom);
    setOpenModal(false);
  };

  var handleClose = function handleClose(e) {
    e.stopPropagation();
    setOpenModal(!openModal);
  };

  var constructPlaceHolderText = function constructPlaceHolderText() {
    var placeHolderText = totalGuests > 1 ? "".concat(totalGuests, " ").concat(guestPlural) : "".concat(totalGuests, " ").concat(guestSingle);
    var placeHolderCharacter = isOnlyApplyForHotel ? ' &' : ',';
    return totalRooms > 1 ? "".concat(placeHolderText).concat(placeHolderCharacter, " ").concat(totalRooms, " ").concat(roomPlural) : "".concat(placeHolderText).concat(placeHolderCharacter, " ").concat(totalRooms, " ").concat(roomSingle);
  };

  var renderPassengerRoomSelection = function renderPassengerRoomSelection() {
    return /*#__PURE__*/_react.default.createElement(_PassengerRoomSelection.default, {
      theme: theme,
      data: _multiRoomSelect.default.generatePassengerRoomSelectionData(data, updatedRoomOccupancy, defaultRoomOccupancy, childAge),
      maxPassengerLimit: maxPassengerLimit,
      onRoomSubmit: onRoomSubmit,
      device: device,
      accessible: accessible,
      alwayEnableAddRoom: alwayEnableAddRoom,
      isShowChildAgeInput: isShowChildAgeInput,
      isShowInfantSelect: isShowInfantSelect
    });
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(MultiRoomSelectWrapper, (0, _extends2.default)({
      ref: wrapperRef,
      onClick: function onClick() {
        return setOpenModal(true);
      },
      tabIndex: tabIndex,
      theme: themeContext
    }, customProperties), /*#__PURE__*/_react.default.createElement(MultiRoomSelectInputWrapper, {
      openModal: openModal
    }, device !== _constant.DEVICE_TYPE.MOBILE && /*#__PURE__*/_react.default.createElement(IconPaxStyle, {
      accessible: accessible,
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      fontsize: isOnlyApplyForHotel ? 'titleNormal' : _constant2.DEFAULT_STYLE.ICON.SIZE,
      icon: iconName
    }), /*#__PURE__*/_react.default.createElement(InputLabelContainer, {
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      viewport: device
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      customProperties: {
        id: 'multi-select-input-label'
      },
      display: "inlineFlex",
      type: "small",
      color: "greyDarker",
      opacity: "50%"
    }, multiRoomSelectTitle), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: true,
      display: "inlineFlex",
      theme: theme,
      type: _constant2.DEFAULT_STYLE.PLACEHOLDER.TYPE
    }, constructPlaceHolderText())), device === _constant.DEVICE_TYPE.MOBILE && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      color: _constant2.DEFAULT_STYLE.DROPDOWN_ICON.COLOR,
      fontsize: _constant2.DEFAULT_STYLE.DROPDOWN_ICON.FONT_SIZE,
      icon: _constant2.DEFAULT_STYLE.DROPDOWN_ICON.ICON,
      theme: theme
    })), device === _constant.DEVICE_TYPE.MOBILE ? openModal && /*#__PURE__*/_react.default.createElement(MobileModal, null, /*#__PURE__*/_react.default.createElement(MobileModalHeader, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: true,
      bold: true,
      display: "inlineFlex",
      theme: "AIRASIA_CLASSIC",
      type: "default"
    }, passengerModalHeaderLabel), /*#__PURE__*/_react.default.createElement(ModalCloseButton, {
      onClick: function onClick(e) {
        return handleClose(e);
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: true,
      color: _constant2.DEFAULT_STYLE.MOBILE_HEADER.ICON.COLOR,
      fontsize: _constant2.DEFAULT_STYLE.MOBILE_HEADER.ICON.SIZE,
      icon: _constant2.DEFAULT_STYLE.MOBILE_HEADER.ICON.TYPE,
      theme: theme
    }))), renderPassengerRoomSelection()) : openModal && /*#__PURE__*/_react.default.createElement(DesktopModal, null, renderPassengerRoomSelection()));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

MultiRoomSelect.propTypes = _multiRoomSelect2.default.PropTypes;
MultiRoomSelect.defaultProps = _multiRoomSelect2.default.DefaultProps;
var _default = MultiRoomSelect;
exports.default = _default;